var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("商品管理")]),
              _c("el-breadcrumb-item", [_vm._v("菜品管理")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.listParams, "label-width": "100px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "分类名称：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { size: "small", clearable: "" },
                              model: {
                                value: _vm.listParams.plaGoodCategoryId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.listParams,
                                    "plaGoodCategoryId",
                                    $$v
                                  )
                                },
                                expression: "listParams.plaGoodCategoryId",
                              },
                            },
                            _vm._l(_vm.categoryNameList, function (item) {
                              return _c("el-option", {
                                key: item.title,
                                attrs: { label: item.title, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.resetAndLoad },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: {
            "page-sizes": [30],
            "page-info": _vm.pager,
            loading: _vm.tableLoading,
          },
          on: { "page-current-change": _vm.handleCurrentChange },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              { staticClass: "wrap-table-info-display" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.toCreate },
                  },
                  [_vm._v(" 新增 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: {
                      disabled: _vm.releaseArr.length === 0,
                      type: "success",
                      size: "small",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.releaseDishes(false)
                      },
                    },
                  },
                  [_vm._v(" 发布菜品 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.releaseDishes(true)
                      },
                    },
                  },
                  [_vm._v(" 发布所有菜品 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.exporttDishList()
                      },
                    },
                  },
                  [_vm._v(" 导出菜品价格清单 ")]
                ),
                _c(
                  "span",
                  { staticClass: "table-info-display" },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: { type: "text" },
                        on: { click: _vm.linkToReleaseRecordPage },
                      },
                      [_vm._v("发布记录")]
                    ),
                    _c("span", [_vm._v("总条数：")]),
                    _c("span", { staticClass: "alert-text ft16" }, [
                      _vm._v(_vm._s(_vm.pager.total)),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              ref: "table",
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              on: {
                "selection-change": _vm.handleSelectionChange,
                "selection-all": _vm.handleSelectionChange,
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", type: "selection", width: "55" },
              }),
              _c("icTableColumnIndex", {
                attrs: {
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodCategoryName",
                  align: "center",
                  label: "分类名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "picture", align: "center", label: "图片" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "wrap-picture-style" }, [
                          _c("img", {
                            attrs: { src: scope.row.picture, alt: "" },
                          }),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "菜品名称" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodSpecName",
                  align: "center",
                  label: "规格(g)",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pieceUnit",
                  align: "center",
                  label: "计价方式",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pieceUnit === 0
                          ? _c("span", [_vm._v("计重")])
                          : _vm._e(),
                        scope.row.pieceUnit === 1
                          ? _c("span", [_vm._v("计件")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "price", align: "center", label: "单价(元)" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleShowPrice(row, 1)
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.price))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.listParams.supplyId === "3"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "referencePrice",
                      align: "center",
                      label: "参考价(元)",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleShowPrice(row, 2)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(row.price))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3606709421
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.editItem(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "confirm-button",
                          {
                            staticStyle: { margin: "0 10px" },
                            attrs: {
                              type: "text",
                              title: "确认要删除该条数据？",
                            },
                            on: {
                              confirmed: function ($event) {
                                return _vm.deleteItem(scope.row.id)
                              },
                            },
                          },
                          [_c("span", [_vm._v("删除")])]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.submitHistory(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("历史提交记录")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialogForm,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.itemParams,
                    rules: _vm.checkItemParams,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "领货日期：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择领货日期",
                            size: "small",
                          },
                          model: {
                            value: _vm.itemParams.supplyDateId,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemParams, "supplyDateId", $$v)
                            },
                            expression: "itemParams.supplyDateId",
                          },
                        },
                        _vm._l(_vm.dateList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { value: item.id, label: item.title },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.isDisabled,
                            size: "small",
                            type: "primary",
                          },
                          on: { click: _vm.confirmRelease },
                        },
                        [_vm._v(" 确认发布 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("DialogHistory", {
        attrs: { dialogVisible: _vm.historyDialogVisible, id: _vm.historyId },
        on: {
          "update:dialogVisible": function ($event) {
            _vm.historyDialogVisible = $event
          },
          "update:dialog-visible": function ($event) {
            _vm.historyDialogVisible = $event
          },
        },
      }),
      _c("DialogPrice", {
        attrs: {
          dialogVisible: _vm.dialogVisiblePrice,
          doalogData: _vm.dialogPriceData,
        },
        on: {
          "update:dialogVisible": function ($event) {
            _vm.dialogVisiblePrice = $event
          },
          "update:dialog-visible": function ($event) {
            _vm.dialogVisiblePrice = $event
          },
          refresh: function ($event) {
            return _vm.loadTableData([])
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }